import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { LoanQueueSearchCriteria } from '@matech/thebigpos-sdk'
import Select from '../select'

type LoanQueueSearchFiltersProps = {
	handleFilterChange: (value: string, filterName: string) => void
	searchCriteria: LoanQueueSearchCriteria
}

const STATUSES: Record<string, string> = {
	Pending: 'loan_queue.filters.statuses.pending',
	Retrying: 'loan_queue.filters.statuses.retrying',
	Successful: 'loan_queue.filters.statuses.successful',
	Failed: 'loan_queue.filters.statuses.failed',
	FailedPermanently: 'loan_queue.filters.statuses.failed_permanently',
	Unknown: 'loan_queue.filters.statuses.unknown',
}

const TYPES: Record<string, string> = {
	New: 'loan_queue.filters.types.new',
	Append: 'loan_queue.filters.types.append',
	Update: 'loan_queue.filters.types.update',
	Document: 'loan_queue.filters.types.document',
	Unknown: 'loan_queue.filters.types.unknown',
}

const REASONS: Record<string, string> = {
	Locked: 'loan_queue.filters.reasons.locked',
	LOSError: 'loan_queue.filters.reasons.los_error',
	Exception: 'loan_queue.filters.reasons.exception',
	Unknown: 'loan_queue.filters.reasons.unknown',
}

const LoanQueueSearchFilters = ({
	handleFilterChange,
	searchCriteria,
}: LoanQueueSearchFiltersProps) => {
	const { formatMessage } = useIntl()

	const { typeOptions, statusOptions, reasonOptions } =
		useMemo(() => {
			const showAllOption = {
				label: formatMessage({ id: 'loan_queue.filters.show_all' }),
				value: 'all',
			}

			const typeOptions = [
				showAllOption,
				...Object.entries(TYPES).map(([value, label]) => ({
					label: formatMessage({ id: label }),
					value,
				})),
			]

			const statusOptions = [
				showAllOption,
				...Object.entries(STATUSES).map(([value, label]) => ({
					label: formatMessage({ id: label }),
					value,
				})),
			]

			const reasonOptions = [
				showAllOption,
				...Object.entries(REASONS).map(([value, label]) => ({
					label: formatMessage({ id: label }),
					value,
				})),
			]
			return { typeOptions, statusOptions, reasonOptions }
		}, [formatMessage])

	return (
		<>
			<Select
				value={searchCriteria.type || 'all'}
				onOptionChange={(e) => handleFilterChange(e, 'type')}
				label={formatMessage({ id: 'global.type' })}
				options={typeOptions}
				disableClear
			/>
			<Select
				value={searchCriteria.status || 'all'}
				onOptionChange={(e) => handleFilterChange(e, 'status')}
				label={formatMessage({ id: 'global.status' })}
				options={statusOptions}
				disableClear
			/>
			<Select
				value={searchCriteria.reason || 'all'}
				onOptionChange={(e) => handleFilterChange(e, 'reason')}
				label={formatMessage({ id: 'global.reason' })}
				options={reasonOptions}
				disableClear
			/>
		</>
	)
}

export default LoanQueueSearchFilters
